//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'operation-btn',
    props: {
      total: {
        type: Number | String,
        default: 0,
      },
      currencyCode: {
        type: String,
        default: 'CNY',
      },
      discountTotal: {  // 优惠总金额
        type: Number,
        default: 0,
      },
    },
    methods: {
      onViewDetail(){
        this.$emit('on-view-detail');
      },

      onGo2Pay(){
	      this.$emit('on-booking');
      },
    },
  }



// WEBPACK FOOTER //
// ./src/views/hotel-booking/components/OperationBtn.vue